'use es6';

import createAction from 'flux-actions/createAction';
import { RECIEVED_PERFORMANCE_DATA_CHECK, REQUESTED_PERFORMANCE_DATA_CHECK, REQUESTED_PERFORMANCE_DATA_CHECK_FAILED } from './ActionTypes';
export const requestedPerformanceDataCheck = createAction(REQUESTED_PERFORMANCE_DATA_CHECK);
export const requestedPerformanceDataCheckSucceeded = createAction(RECIEVED_PERFORMANCE_DATA_CHECK, data => ({
  data
}));
export const requestedPerformanceDataCheckFailed = createAction(REQUESTED_PERFORMANCE_DATA_CHECK_FAILED, error => ({
  error
}));